var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<span ng-if=\"vm.parameter[vm.key].wert\"><ul><li ng-repeat=\"wert in vm.parameter[vm.key].wert track by $index\">{{ vm.showValue(wert) }}{{$last ? '' : ', '}}</li></ul></span><span ng-if=\"!vm.parameter[vm.key].wert || vm.parameter[vm.key].wert.length === 0\">Keine Angabe</span>");;return buf.join("");
}